import { client } from "../sanity/client";

export const getCategories = async () => {

    const query = `
    *[_type == "category"] | order(title asc){
        _id,
        title,
        slug,
        description
    }
    `;

    return await client.fetch(query);

};